import {
  addDependencies,
  andDependencies,
  ceilDependencies,
  create,
  divideDependencies,
  evaluateDependencies,
  floorDependencies,
  formatDependencies,
  maxDependencies,
  minDependencies,
  notDependencies,
  orDependencies,
  parseDependencies,
  roundDependencies,
  sqrtDependencies,
  subtractDependencies,
  sumDependencies,
} from 'mathjs';
import { ComputeMathDateFunctions } from './functions/ComputeMathDateFunctions.ts';
import { ComputeMathListFunctions } from './functions/ComputeMathListFunctions.ts';
import { ComputeMathLogicFunctions } from './functions/ComputeMathLogicFunctions.ts';
import { ComputeMathOtherFunctions } from './functions/ComputeMathOtherFunctions.ts';

export const ComputeMath = create(
  {
    addDependencies,
    subtractDependencies,
    divideDependencies,
    formatDependencies,
    parseDependencies,
    orDependencies,
    andDependencies,
    notDependencies,
    minDependencies,
    maxDependencies,
    sqrtDependencies,
    sumDependencies,
    floorDependencies,
    roundDependencies,
    ceilDependencies,
    evaluateDependencies,
  },
  {
    predictable: true,
  },
);

/**
 * Includiamo tutte le funzioni disponibili; se non definiscono `fn` vengono
 * usate solo per la documentazione.
 */
export const ComputeMathAllFunctions = [
  // Funzioni sulle liste
  ...ComputeMathListFunctions,
  // Funzioni logiche
  ...ComputeMathLogicFunctions,
  // Funzioni generiche
  ...ComputeMathOtherFunctions,
  // Funzioni sulle date
  ...ComputeMathDateFunctions,
];

// Importiamo tutte le funzioni personalizzate dentro `ComputeMath`
ComputeMath.import(
  ComputeMathAllFunctions.filter(f => f.fn != null).map(f => ({
    [f.name]: f.fn!(ComputeMath),
  })),
);

// Rimuoviamo le funzioni che non vogliamo esportare
ComputeMath.import(
  {
    import() {
      throw new Error('Function import is disabled');
    },
    createUnit() {
      throw new Error('Function createUnit is disabled');
    },
    // parse: function () {
    //   throw new Error('Function parse is disabled');
    // },
    simplify() {
      throw new Error('Function simplify is disabled');
    },
    derivative() {
      throw new Error('Function derivative is disabled');
    },
  },
  { override: true },
);
